<script setup lang="ts">
import { toRef } from 'vue';
import { useEventStore } from '@/stores/event/event.store';
import { useStateStore } from '@/stores/state.store';

const eventStore = useEventStore();
const stateStore = useStateStore();

const mainColor = toRef(() => stateStore.getColors.mainColor);
const headerFont =
  eventStore.getCommonData.headerFont &&
  eventStore.getCommonData.headerFont.trim() !== ''
    ? eventStore.getCommonData.headerFont
    : 'Petit Formal Script';

const header = toRef(() => eventStore.getLangData('header'));
</script>

<template>
  <div class="head">
    <h1 v-if="header" class="header custom-font">{{ header }}</h1>
    <svg
      v-else
      class="star"
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26 51C25.95 37.2099 14.7764 26.0463 1 26.0463C14.8071 26.0463 26 14.8326 26 1C26.0498 14.7901 37.2236 25.9537 51 25.9537C37.1927 25.9537 26 37.1674 26 51Z"
        :stroke="mainColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<style lang="scss">
.head {
  border-bottom: 1px solid v-bind(mainColor);
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 500px) {
    padding: 0;
    padding-bottom: 5px;
  }

  .header {
    font-size: 4em;
    line-height: normal;
    text-align: center;

    @media screen and (max-width: 500px) {
      font-size: 2.7em;
    }

    @media screen and (max-width: 350px) {
      font-size: 2.4em;
    }
  }

  .star {
    @media screen and (max-width: 500px) {
      width: 20px;
      height: 20px;
    }
  }
}

.custom-font {
  font-family: v-bind(headerFont), 'Petit Formal Script', serif;
}
</style>
